import { apiClient } from "../api/apiclient"

export const getCourse = (token) =>
    apiClient.get("/courses", {
        headers: { Authorization: `Bearer ${token}` },
    });


export const getTabs = (token) =>
    apiClient.get("/tabs", {
        headers: { Authorization: `Bearer ${token}` },
    });


export const AssignTabsToCourse = (courseId, token, tabIds) =>
    apiClient.post(
        `/courses/${courseId}/assign-tabs`,
        tabIds,
        {
            headers: { Authorization: `Bearer ${token}` },
        }
    );

export const getAllCourseTabs = (token) =>
    apiClient.get("/course-tabs", {
        headers: { Authorization: `Bearer ${token}` },
    });

export const updateTabsForCourse = (courseId, token, tabIds) =>
    apiClient.put(
        `/courses/${courseId}/update-tabs`,
        tabIds,
        {
            headers: { Authorization: `Bearer ${token}` },
        }
    );
